import React, { Component } from 'react'
import styled from 'styled-components'

const Item = styled.div`
  display: inline-block;
  width: 120px;
  cursor: pointer;
`
const StyledInput = styled.input`
  width: 150px;
`

const t = {
  name_placeholder: 'Название точки'
}

export default class PointEditorComponent extends Component {
  constructor(props) {
    super(props)
    this.valueStep = 0.1

    this.state = { radius: props.point.radius, name: props.point.name }
  }

  render() {
    return (
      <div>
        <label>
          <StyledInput
            type="text"
            className="input-item"
            value={this.state.name}
            placeholder={t.name_placeholder}
            onChange={(e) => {
              this.setState({ name: e.target.value })
              this.props.onNameChange && this.props.onNameChange(e.target.value)
            }}
          />
          <Item
            onClick={() => this.coordClicked()}
            onMouseOver={() => this.coordMouseOver()}
            onMouseOut={() => this.coordMouseOut()}
          >
            <span>{this.pointText()} </span>
          </Item>
          <input
            type="number"
            className="input-item input-item_small"
            min={this.props.minValue}
            max={this.props.maxValue}
            step={this.valueStep}
            value={this.state.radius}
            onChange={(e) => this.inputChanged(e)}
          />
          <span> {this.props.units} </span>
          <a onClick={(e) => this.deleteClicked(e)} href="#">
            [x]
          </a>
        </label>
      </div>
    )
  }

  coordClicked() {
    this.props.onCoordClick && this.props.onCoordClick()
  }

  coordMouseOver() {
    this.props.onCoordMouseOver && this.props.onCoordMouseOver()
  }

  coordMouseOut() {
    this.props.onCoordMouseOut && this.props.onCoordMouseOut()
  }

  deleteClicked(e) {
    e.preventDefault()
    this.props.onDeleteClick && this.props.onDeleteClick()
  }

  inputChanged(e) {
    let radius = e.target.value
    radius = this.correctedValue(radius)
    this.setState({ radius })
    this.props.onRadiusChange && this.props.onRadiusChange(radius)
  }

  roundFloat(num) {
    return Math.round(num * 10000) / 10000
  }

  pointText() {
    return (
      this.roundFloat(this.props.point.latitude) +
      ', ' +
      this.roundFloat(this.props.point.longitude)
    )
  }

  correctedValue(val) {
    if (!val || val < this.props.minValue) {
      return this.props.minValue
    } else if (val > this.props.maxValue) {
      return this.props.maxValue
    } else {
      return Math.round(val * 10) / 10
    }
  }
}
